module.exports = __webpack_public_path__ + "img/whiteTongDeng.80a153ad.png";